import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

export const HomeViewWeb: React.FC = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Welcome to ChildNav 🏠</Text>
      <Text style={styles.description}>
        Your child development companion. Navigate through different sections using the tabs below.
      </Text>
      <View style={styles.featuresContainer}>
        <Text style={styles.featuresTitle}>Quick Access:</Text>
        <Text style={styles.feature}>🌟 Track milestones</Text>
        <Text style={styles.feature}>⚠️ Address concerns</Text>
        <Text style={styles.feature}>🏥 Plan well-visits</Text>
        <Text style={styles.feature}>📚 Get guidance</Text>
        <Text style={styles.feature}>✅ Complete actions</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    backgroundColor: '#f8f9fa',
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#2c3e50',
    marginBottom: 16,
    textAlign: 'center',
  },
  description: {
    fontSize: 16,
    color: '#7f8c8d',
    textAlign: 'center',
    marginBottom: 30,
    lineHeight: 24,
  },
  featuresContainer: {
    backgroundColor: '#ffffff',
    padding: 20,
    borderRadius: 12,
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  featuresTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#2c3e50',
    marginBottom: 12,
  },
  feature: {
    fontSize: 16,
    color: '#34495e',
    marginBottom: 8,
    paddingLeft: 8,
  },
});